module.exports = __webpack_public_path__ + "img/pdf.be62956b.png";